// /not-provisioned — auth succeeded, but no portal_users row matches.
// Per spec §2.2 step 5: "your account isn't set up yet, contact support@solomonadvising.com"

import { useEffect } from 'react';
import { signOut } from '../lib/auth';
import brandmarkBlack from '../assets/solomon-brandmark-black.svg';

export function NotProvisionedRoute(): React.ReactNode {
  useEffect(() => {
    // Sign the user out so they don't sit on a half-authenticated session.
    void signOut();
  }, []);

  return (
    <main
      id="main-content"
      tabIndex={-1}
      className="flex min-h-screen items-center justify-center bg-cream px-6 py-12 focus:outline-none"
    >
      <div className="w-full max-w-md">
        <div className="mb-10 flex justify-center">
          <img src={brandmarkBlack} alt="Solomon Advising" className="h-12 w-auto" />
        </div>
        <div className="rounded-md border border-border-light bg-white p-8 shadow-card">
          <h1 className="mb-3 text-[28px]">Account not yet set up</h1>
          <p className="mb-4">
            Your sign-in worked, but Solomon hasn&rsquo;t finished setting up your portal access.
            Please email{' '}
            <a className="underline hover:text-orange" href="mailto:support@solomonadvising.com">
              support@solomonadvising.com
            </a>{' '}
            and we&rsquo;ll get you in.
          </p>
          <p className="text-text-muted">
            (You&rsquo;ve been signed out so this page is safe to leave open.)
          </p>
        </div>
      </div>
    </main>
  );
}
